import { Component, OnInit } from '@angular/core';
import {
    CommonLegendService,
    IChartLegendItem,
} from 'src/app/services/common-legend.service';

@Component({
    selector: 'app-common-legend',
    templateUrl: './common-legend.component.html',
    styleUrls: ['./common-legend.component.scss'],
})
export class CommonLegendComponent implements OnInit {
    distinctIds: string[] = [];
    // TODO rozrzeczyć logikę
    // Mogą powstać grupy legend. Część wykrtesów będzie miała 1 zestaw nazw, część inny
    // Trzeba to rozdzielić
    grouppedItems: IChartLegendItem[][] = [];

    constructor(public legendService: CommonLegendService) {}

    ngOnInit() {
        this.legendService.registeredLegendItems$.subscribe(
            (registeredLegends: IChartLegendItem[][]) => {
                this.grouppedItems = registeredLegends;
            }
        );
        console.log('CommonLegendComponent.ngOnInit');
    }

    toggleLegend(splitId: string) {
        this.legendService.requestToggleLegend(splitId);
    }
}
